import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d988e88a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d988e88a')) {
      api.createRecord('d988e88a', component.options)
    } else {
      api.reload('d988e88a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d988e88a", function () {
      api.rerender('d988e88a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Doc/index.vue"
export default component.exports